import { useContext } from "react";
import { U2000AuthContext, type U2000AuthContextType } from "./U2000AuthContext";

export function useU2000AuthContext(): U2000AuthContextType {
  const context = useContext(U2000AuthContext);

  if (!context) {
    throw new Error("useU2000AuthContext must be used within a U2000AuthProvider");
  }
  return context;
}
